import { TranslatePipe } from '../../filters/translate.pipe';
import { CardCoachingTopicComponent } from '../../components/card-coaching-topic/card-coaching-topic.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import UrlUtil from '../../utils/url-util.service';
import Session from '../../utils/session.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'list-coaching-topics',
	templateUrl: './list-coaching-topics.component.html',
	imports: [ CommonModule, TranslatePipe, CardCoachingTopicComponent, FormsModule ]
})
export class ListCoachingTopicsComponent implements OnInit {
	private urlUtil: UrlUtil = inject(UrlUtil);
	private session: Session = inject(Session);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	@Input() coachingTopics: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.handleSelection = this.handleSelection;
		this.vm.rootTopics = true;
		this.vm.user = this.session.getSession().user;
		
		this.vm.displayedCoachingTopics = [];
		this.vm.displayedCoachingTopicIds = [];
		
		this.vm.titleText = this.angularFilterHelperService.translate('Booking.Instant.Title_Coaching_Topics');
		this.vm.navigateBack = this.navigateBack;
		
		var search: any = this.urlUtil.getSearchParams();
		if (search.coachingTopics) {
			var selectedTopics: any = search.coachingTopics.split(",");
			for (var i = 0; i < this.vm.coachingTopics.length; i++) {
				if (selectedTopics[0] == this.vm.coachingTopics[i].id) {
					this.handleSelection(this.vm.coachingTopics[i].parent);
					break;
				}
			}
		} else {
			for (var i = 0; i < this.vm.coachingTopics.length; i++) {
				if (!this.vm.displayedCoachingTopicIds.includes(this.vm.coachingTopics[i].parent.id)) {
					this.vm.displayedCoachingTopicIds.push(this.vm.coachingTopics[i].parent.id);
					this.vm.displayedCoachingTopics.push(this.vm.coachingTopics[i].parent);
				}
			}
		}
	}
	
	handleSelection = (coachingTopic) => {
		this.vm.params = this.angularRoutingHelperService.getQueryParams();
		if (coachingTopic.type == 'COACHING_GROUP') {
			this.vm.rootTopics = false;
			this.vm.displayedCoachingTopics = [];
			this.vm.displayedCoachingTopicIds = [];
			this.vm.titleText = (coachingTopic.translation && coachingTopic.translation.title)
				? coachingTopic.translation.title
				: coachingTopic.title;
			for (var i = 0; i < this.vm.coachingTopics.length; i++) {
				if (coachingTopic.id == this.vm.coachingTopics[i].parent.id) {
					this.vm.displayedCoachingTopicIds.push(this.vm.coachingTopics[i].id);
					this.vm.displayedCoachingTopics.push(this.vm.coachingTopics[i]);
				}
			}
			if (!this.vm.params['showCoaching']) {
				var search: any = this.urlUtil.getSearchParams();
				search.showCoaching = "true";
				this.angularRoutingHelperService.setQueryParams(search);
			}
		} else {
			var search: any = this.urlUtil.getSearchParams();
			// this.updateMultipleTopicsSelection(search, coachingTopic);
			this.updateSingleTopicSelection(search, coachingTopic);
			this.angularRoutingHelperService.setQueryParams(search);
		}
	}
	
	updateSingleTopicSelection(search, coachingTopic) {
		search.coachingTopics = coachingTopic.id;
	}
	
	updateMultipleTopicsSelection(search, coachingTopic) {
		if (search.coachingTopics) {
			search.coachingTopics = Array.isArray(search.coachingTopics)
			? search.coachingTopics.join(',')
			: search.coachingTopics.toString();
		}
		if (!search.coachingTopics) {
			search.coachingTopics = coachingTopic.id;
		} else if (search.coachingTopics.indexOf(coachingTopic.id) == -1) {
			search.coachingTopics += ("," + coachingTopic.id);
		} else {
			var selectedTopics: any = search.coachingTopics.split(",");
			var index: any = selectedTopics.indexOf(coachingTopic.id.toString());
			if (index > -1) {
				selectedTopics.splice(index, 1);
			}
			search.coachingTopics = selectedTopics.join(',');
			if (!search.coachingTopics) {
				search.coachingTopics = undefined;
			}
		}
	}
	
	navigateBack() {
		if (this.vm.rootTopics) {
			this.angularRoutingHelperService.setQueryParams({});
		} else {
			this.vm.rootTopics = true;
			this.vm.titleText = this.angularFilterHelperService.translate('Booking.Instant.Title_Coaching_Topics');
			this.vm.displayedCoachingTopics = [];
			this.vm.displayedCoachingTopicIds = [];
			for (var i = 0; i < this.vm.coachingTopics.length; i++) {
				if (!this.vm.displayedCoachingTopicIds.includes(this.vm.coachingTopics[i].parent.id)) {
					this.vm.displayedCoachingTopicIds.push(this.vm.coachingTopics[i].parent.id);
					this.vm.displayedCoachingTopics.push(this.vm.coachingTopics[i].parent);
				}
			}
			if (this.vm.user.origin == 'siffi.com') {
				var search: any = this.urlUtil.getSearchParams();
				search.coachingTopics = undefined;
				search.showCoaching = undefined;
				this.angularRoutingHelperService.setQueryParams(search);
			} else {
				this.angularRoutingHelperService.setQueryParam('coachingTopics', null);
			}
		}
	}
	
}